import React, { useEffect, useState } from "react";
import { request } from "../../../utils/request";
import { formatCurrency } from "../../../utils/helpers";
import Loader from "../../general/Loader";

const TarjetaEgresos = ({anio, mes, vendedor, styles}) => {
    const tarjeta = "egresos";
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(true)

    const getData = async (anio,mes) => {
        setLoading(true);
        const req = await request(`dashboard/gi?tarjeta=${tarjeta}&mes=${mes}&anio=${anio}&vendedor=${vendedor ? 1 : 0}`);

        if (req.success) {
            setData(req.data);
            setLoading(false);
        }
    };

    useEffect(() => {
      getData(anio,mes);
    }, [anio, mes]);

    if (loading === true) {
        return <div style={styles.columnStyles}>
            <Loader />
        </div>;
    }

    return (
        <div style={styles.columnStyles}>
            <div style={styles.columnContainer}>
                <div style={styles.header}>
                    <div className="color-primary" style={styles.principal}>
                        {formatCurrency(Number(data?.totalEgresos) + Number(data?.nomina))}
                    </div>
                    <div style={styles.subtitulo}>
                        Egresos
                    </div>
                </div>

                <div className="row">
                    {data?.egresosFactura > 0 && (
                        <div style={styles.infoBlock}>
                            <div>
                                <strong>{formatCurrency(Number(data?.egresosFactura) + Number(data?.nomina))}</strong>
                            </div>
                            <small style={styles.label}>Periodo Actual</small>
                        </div>
                    )}
                    {data?.egresosRecibo  > 0 && (
                        <div style={styles.infoBlock}>
                            <div>
                                <strong>{formatCurrency(data?.egresosRecibo)}</strong>
                            </div>
                            <small style={styles.label}>Cuentas por Pagar</small>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default TarjetaEgresos;
